import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import {BASE_DOMAIN, PAGE_TYPE} from "./shared/constants";
import {CircularProgress} from "@mui/material";

const MemberDashboard = lazy(() =>
  import("./member-dashboard/components/pages/dashboard/MemberDashboard")
);
const Home = lazy(() => import("./yogawav-home/components/pages/Home"));
const EnquiryPage = lazy(() => import("./yogawav-home/components/pages/EnquiryPage"));
const BetaHome = lazy(() => import("./beta-home/components/pages/BetaHome"));
const MemberLoginPage = lazy(() =>
  import("./member-dashboard/components/pages/MemberLoginPage")
);
const TestimonialsPage = lazy(() => import("./beta-home/components/pages/TestimonialsPage/TestimonialsPage"));
const ServicesPage = lazy(() => import("./beta-home/components/pages/ServicesPage/ServicesPage"));
const WhyUsPage = lazy(() => import("./beta-home/components/pages/WhyUsPage/WhyUsPage"));
const BatchesPage = lazy(() =>
  import("./beta-home/components/pages/batches/batches-page/BatchesPage")
);
const BatchPage = lazy(() =>
  import("./beta-home/components/pages/batches/batch-page/BatchPage")
);
const EventsListingPage = lazy(() =>
  import("./beta-home/components/pages/Events/EventsListingPage")
);
const EventPage = lazy(() =>
  import("./beta-home/components/pages/Events/EventPage")
);
const PageNotFound = lazy(() =>
  import("./beta-home/components/layouts/pageNotFound/PageNotFound")
);
const PrivacyPolicy = lazy(() => import("./yogawav-home/components/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./yogawav-home/components/pages/TermsOfService"));
const RCPolicy = lazy(() => import("./yogawav-home/components/pages/RCPolicy"));
const ReportAbuse = lazy(() => import("./yogawav-home/components/pages/ReportAbuse"));
const AboutUsPage = lazy(() => import("./yogawav-home/components/pages/AboutUsPage"));
const ContactUsPage = lazy(() => import("./yogawav-home/components/pages/ContactUsPage"));
const NextStepAfterLoginPage = lazy(() => import("./yogawav-home/components/pages/NextStepAfterLoginPage"));
const ContactWhatsapp = lazy(() => import("./yogawav-home/components/pages/ContactWhatsappPage"));
const AppointmentPage = lazy(() =>
  import("./beta-home/components/pages/AppointmentPage/AppointmentPage")
);
const LeadEnquiryPage = lazy(() =>
  import("./beta-home/components/pages/Lead EnquiryPage/LeadEnquiryPage")
);
const PolicyPage = lazy(() => import("./beta-home/components/pages/PolicyPage/PolicyPage"));
const EnquiryThankYouPage = lazy(() =>
  import("./yogawav-home/components/pages/EnquiryThankYouPage")
);
const YogappifyCoachingPage = lazy(() =>
  import("./yogawav-home/components/pages/YogappifyCoachingPage")
);
const YogappifyImpactPage = lazy(() =>
  import("./yogawav-home/components/pages/YogappifyImpactPage")
);
const YogappifyGoogleAdsPage = lazy(() =>
  import("./yogawav-home/components/pages/YogappifyGoogleAdsPage")
);
const YogappifyGoogleAdsPageV2 = lazy(() =>
  import("./yogawav-home/components/pages/YogappifyGoogleAdsPageV2")
);
const YogappifyMentorshipPage = lazy(() =>
  import("./yogawav-home/components/pages/YogappifyMentorshipPage")
);

function Loader() {
  return (
    <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100vh",}}>
      <CircularProgress />
    </div>
  );
}

const setCookieForUTM = () => {
  const params = new URLSearchParams(window.location.search);

  const utmData = {
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_source: params.get("utm_source"),
    gclid: params.get("gclid"),
    fbclid: params.get("fbclid"),
  };

  if (utmData.utm_medium || utmData.utm_campaign || utmData.utm_source || utmData.gclid || utmData.fbclid) {
    document.cookie =
        "utm_data=" + encodeURIComponent(JSON.stringify(utmData)) + ";" +
        `domain=.${BASE_DOMAIN};` +
        "path=/;" +
        "max-age=2592000";
  }
}

export default function App(props) {
  if (props.pageType === PAGE_TYPE.ALPHA_LANDING) {
    return (
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<BetaHome />} />
          <Route path="member" element={<MemberDashboard />} />
          <Route path="batches" element={<BatchesPage />} />
          <Route path="testimonials" element={<TestimonialsPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="why-us" element={<WhyUsPage />} />
          <Route path="batch/:batchId" element={<BatchPage />} />
          <Route path="events" element={<EventsListingPage/>}/>
          <Route path="event/:eventCode" element={<EventPage/>}/>
          <Route path="enquiry" element={<LeadEnquiryPage />} />
          <Route path="appointment" element={<AppointmentPage />} />
          <Route
            path="terms-of-service"
            element={<PolicyPage title="Terms of Service" />}
          />
          <Route
            path="privacy-policy"
            element={<PolicyPage title="Privacy Policy" />}
          />
          <Route
            path="refund-policy"
            element={<PolicyPage title="Refund Policy" />}
          />
          <Route
            path="cancellation-policy"
            element={<PolicyPage title="Cancellation Policy" />}
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    );
  } else if (props.pageType === PAGE_TYPE.NOT_FOUND) {
    return (
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    );
  } else {
    setCookieForUTM()
    return (
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="yogappify-coaching" element={<YogappifyCoachingPage />} />
          <Route path="impact" element={<YogappifyImpactPage />} />
          <Route path="yoga-teacher-management-app-1" element={<YogappifyGoogleAdsPage />} />
          <Route path="yoga-teacher-management-app-2" element={<YogappifyGoogleAdsPageV2 />} />
          <Route path="yoga-teacher-mentorship" element={<YogappifyMentorshipPage />} />
          <Route path="enquiry">
            <Route index element={<EnquiryPage />} />
            <Route path="thankyou" element={<EnquiryThankYouPage />} />
          </Route>
          <Route path="auth" element={<MemberLoginPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="rcpolicy" element={<RCPolicy />} />
          <Route path="report-abuse" element={<ReportAbuse />} />
          <Route path="contact-us" element={<ContactUsPage />} />
          <Route path="about-us" element={<AboutUsPage />} />
          <Route path="contact-yogappify-by-whatsapp" element={<ContactWhatsapp />} />
          <Route path="next-steps-link" element={<NextStepAfterLoginPage />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    );
  }
}
